module.exports = __webpack_public_path__ + "static/img/coupon-bg-center.0b3b845.png";